import { createApp } from 'vue';

import main from "main.vue";
import createDynamicRouter from "config/router";

import moment from "moment";

import ElementPlus from 'element-plus';
import ElementPlusLocale from 'element-plus/es/locale/lang/nl';
import dayjs from 'dayjs';
// set first day of week to Monday
dayjs.Ls.en.weekStart = 1;
dayjs.Ls.nl ??= {};
dayjs.Ls.nl.weekStart = 1;

import VueApexCharts from "vue3-apexcharts";
import VueClickAway from "vue3-click-away";
import PrimeVueConfig from "primevue/config";

import trans from "helpers/_translation";

import timeago from 'vue-timeago3';
import { nl, enGB as en } from 'date-fns/locale';
import { lang } from "helpers/_translation";

import DetailOverview from "components/detail-overview";

import { useViewportHeight } from 'composables/useViewportHeight';

// Set our app
const target = document.querySelector("#app");
const settings = Object.assign({}, target.dataset);

(async () => {

	const router = await createDynamicRouter();

	useViewportHeight(); // Set vh early

	const app = createApp(main, settings);

	app.component('DetailOverview', DetailOverview);

	app.use(router)
	.use(ElementPlus, {
		locale: ElementPlusLocale,
	})
	.use(VueApexCharts)
	.use(VueClickAway)
	.use(timeago, {
		locale: lang === "nl" ? nl : en,
		autoUpdate: 10
	})
	.use(PrimeVueConfig, {
		locale: {
			startsWith: 'Starts with',
			contains: 'Contains',
			notContains: 'Not contains',
			endsWith: 'Ends with',
			equals: 'Equals',
			notEquals: 'Not equals',
			noFilter: 'No Filter',
			lt: 'Less than',
			lte: 'Less than or equal to',
			gt: 'Greater than',
			gte: 'Greater than or equal to',
			dateIs: 'Date is',
			dateIsNot: 'Date is not',
			dateBefore: 'Date is before',
			dateAfter: 'Date is after',
			clear: 'Clear',
			apply: 'Apply',
			matchAll: 'Match All',
			matchAny: 'Match Any',
			addRule: 'Add Rule',
			removeRule: 'Remove Rule',
			accept: 'Yes',
			reject: 'No',
			choose: 'Choose',
			upload: 'Upload',
			cancel: 'Cancel',
			dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
			dayNamesShort: ["Zo","Ma","Di","Wo","Do","Vr","Za"],
			dayNamesMin: ["Zo","Ma","Di","Wo","Do","Vr","Za"],
			monthNames: ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],
			monthNamesShort: ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],
			today: 'Today',
			weekHeader: 'Wk',
			firstDayOfWeek: 0,
			dateFormat: 'mm/dd/yy',
			weak: 'Weak',
			medium: 'Medium',
			strong: 'Strong',
			passwordPrompt: 'Enter a password',
			emptyFilterMessage: 'No results found',
			emptyMessage: 'No available options'
		}
	});

app.config.globalProperties.$filters = {
	formatDate(value) {
		// console.log("value",value);
		if (value) {
			return moment(String(value)).locale('nl').format('DD MMMM YYYY HH:mm') + " uur";
		}
	},
	formatPostDate(value) {
		// console.log("value",value);
		if (value) {
			const current = moment(String(value)).locale('nl');
			if (current.isSame(new Date(), "day")) {
				return trans("Vandaag") + " " + current.format('HH:mm');
			} else if (current.isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
				return trans("Gisteren") + " " + current.format('HH:mm');
			} else {
				return current.format('DD MMMM YYYY HH:mm');
			}
		}
	}
};

// Mount it
app.mount(target);
})();